<template>
  <head>
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
  </head>
  <router-view />
</template>

<script setup>
</script>

<style lang="scss">
@use '@/style.scss' as *;

</style>
